import styled from 'styled-components';

export const StyledLink = styled.a`
  color: var(--color-text-muted);
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    color: var(--color-link);
    cursor: pointer;
  }
`;
